export default {
  inheritAttrs: false,
  props: {
    form: {
      type: Object,
      required: false,
      default: () => ({}),
    },
    buttons: {
      type: Array,
      required: false,
      default: () => [],
    },
  },
  data() {
    return {
      validStates: [],
    };
  },
  computed: {
    hasButtons() {
      return this.buttons && this.buttons.length;
    },
    cardStyles() {
      if (!this.hasButtons && !this.$slots.buttons) {
        return { 'max-width': `calc(100% - ${24}px)` };
      } else {
        let width = 50;
        this.buttons.forEach((button) => {
          if (button.title) {
            width += button.title.length * 7 + 80;
          } else {
            width += 50;
          }
        });
        if (width > 400) {
          return { display: 'none' };
        }
        return { 'max-width': `calc(100% - ${width}px)` };
      }
    },
    formValue() {
      if (this.form) {
        return this.form.value;
      }
      return true;
    },
  },
  watch: {
    buttons: {
      handler(newV) {
        this.validStates = (newV || []).map((button) => button.valid === undefined || button.valid);
      },
      deep: true,
    },
  },
  mounted() {
    this.validStates = (this.buttons || []).map((button) => button.valid === undefined || button.valid);
  },
  methods: {
    exec(a) {
      if (a) {
        this.$emit(a);
      }
    },
  },
};
